{
    "NAME": "UsersListLanguage",
    "UsersList_Column_FullName": "Full name",
    "UsersList_Column_Username": "Username",
    "UsersList_Column_LockOut": "Locked out",
    "UsersList_Column_ActivityLastLogon": "Activity/Last Logon",
    "UsersList_Tooltip_LastLogon_Label": "Last logon",
    "UsersList_LastLogon_None": "No data",
    "UsersList_Column_Permissions": "Permissions",
    "UsersList_Column_TelSys": "Telephony server",
    "UsersList_LockOut_Yes": "Yes",
    "UsersList_LockOut_No": "No",
    "UsersList_Filter_UserType_Label": "User type",
    "UsersList_UserType_All": "All",
    "UsersList_UserType_ServiceWide": "Service wide",
    "UsersList_UserType_SystemWide": "System wide",
    "UsersList_UserType_Detached": "Detached",
    "UsersList_UserType_AdminInclusive": "Administrators (inclusive)",
    "UsersList_UserType_AdminExclusive": "Administrators (exclusive)",
    "UsersList_UserType_ReportingHistoricOnly": "Reporting (historic only)",
    "UsersList_UserType_ReportingBLF": "Reporting (BLF)",
    "UsersList_UserType_ReportingStd": "Reporting (standard)",
    "UsersList_UserType_ReportingACD": "Reporting (ACD)",
    "UsersList_UserType_ReportingMobileAppAdvanced": "Reporting (advanced mobile app)",
    "UsersList_UserType_SignedInNow": "Signed in now",
    "UsersList_UserType_SignedInToday": "Signed in today",
    "UsersList_UserType_SignedInThisWeek": "Signed in this week",
    "UsersList_UserType_SignedInThisMonth": "Signed in this month",
    "UsersList_UserType_SignedInNever": "Never signed in",
    "UsersList_UserType_ActivityToday": "Activity today",
    "UsersList_UserType_ActivityThisWeek": "Activity this week",
    "UsersList_UserType_ActivityThisMonth": "Activity this month",
    "UsersList_UserType_ActivityNone": "No activity",
    "UsersList_CopyReports_Button": "Copy reports to",
    "UsersList_BulkAdd_Button": "Bulk Add",
    "UsersList_SignInAs_Button": "Sign in as",
    "UsersList_SignInAs_Confirm": "Sign in as **{}**? You will continue as that user in this browser session.",
    "UsersList_CopyReports_Dialog_Title": "Copy reports from **{} ({})**",
    "UsersList_CopyReports_Step_Reports": "Reports",
    "UsersList_CopyReports_Step_Targets": "Target users",
    "UsersList_CopyReports_Step_Confirm": "Confirm",
    "UsersList_CopyReports_Intro_Reports": "Select one or more reports to copy from **{}**.",
    "UsersList_CopyReports_Intro_Targets": "Select one or more users who should receive copies of those reports.",
    "UsersList_CopyReports_Confirm_Summary": "You will copy **{}** report(s) to **{}** user(s).",
    "UsersList_CopyReports_Confirm_Report_Label": "Copying **{}** report:",
    "UsersList_CopyReports_Confirm_Reports_Label": "Copying **{}** reports:",
    "UsersList_CopyReports_Confirm_Target_Label": "To **{}** user:",
    "UsersList_CopyReports_Confirm_Targets_Label": "To **{}** users:",
    "UsersList_CopyReports_Overwrite_Label": "Replace existing reports on target users when names conflict",
    "UsersList_CopyReports_Success": "Reports copied successfully.",
    "UsersList_CopyReports_Cancel": "Cancel",
    "UsersList_CopyReports_Back": "Back",
    "UsersList_CopyReports_Next": "Next",
    "UsersList_CopyReports_Copy": "Copy reports",
    "UsersList_CopyReports_Column_Folder": "Folder",
    "UsersList_CopyReports_Column_ReportName": "Report",
    "UsersList_CopyReports_Column_Type": "Type",
    "UsersList_CopyReports_Column_Username": "Username",
    "UsersList_CopyReports_Column_FullName": "Full name",
    "UsersList_CopyReports_Empty_Reports": "There are no reports available to copy for this user.",
    "UsersList_CopyReports_Empty_Targets": "There are no eligible target users in scope for this copy operation."
}
